HTML5Backend = require 'react-dnd-html5-backend'
PopOver = require 'views/lib/pop-over'
React = require 'react'
globalClickHandler = require './global-click-handler'
ReactDnd = require 'react-dnd'

_ReactRootComponent = class extends React.Component
  displayName: 'ReactRootComponent'

  render: ->
    React.createElement 'div',
      className: 'js-react-root'
      onClick: @dismissPopover
    , @props.children

  dismissPopover: (e) ->
    if e.isDefaultPrevented()
      return

    globalClickHandler(e)

    return

module.exports = ReactDnd.DragDropContext(HTML5Backend)(_ReactRootComponent)



// WEBPACK FOOTER //
// ./app/scripts/views/internal/react-root-component.coffee